import React from 'react';
import styled from 'styled-components';
import { BodyBold } from '@components/dashboard/Typography';
import Colors from '@components/shared/Colors';
import MoneyIcon from '@images/vms-account/vms-icons/Money.svg';
import TimeIcon from '@images/vms-account/vms-icons/Time.svg';

interface PriceDetailProps {
  currencySymbol: string;
  price: number;
  originalPrice?: number;
  duration: string;
  datatestid: string;
}

const ConsultationPriceDetails: React.FC<PriceDetailProps> = ({ currencySymbol, price, originalPrice, duration, datatestid }) => {
  const displayPrice = price?.toFixed(2)?.split('.') ?? ['0', '00'];
  const displayOriginalPrice = originalPrice?.toFixed(2)?.split('.') ?? ['0', '00'];

  return (
    <Container className="consultation-price-details" data-testid={datatestid}>
      {price ? (
        <DetailWrap>
          <MoneyIcon />
          {originalPrice ? (
            <PriceWrapper>
              <OriginalPrice>
                {currencySymbol}
                {displayOriginalPrice[0]}
                {displayOriginalPrice[1] !== '00' ? <sup>{displayOriginalPrice[1]}</sup> : null}
              </OriginalPrice>
              <DiscountedPrice>
                {currencySymbol}
                {displayPrice[0]}
                {displayPrice[1] !== '00' ? <sup>{displayPrice[1]}</sup> : null}
              </DiscountedPrice>
            </PriceWrapper>
          ) : (
            <Price>
              {currencySymbol}
              {displayPrice[0]}
              {displayPrice[1] !== '00' ? <sup>{displayPrice[1]}</sup> : null}
            </Price>
          )}
        </DetailWrap>
      ) : null}
      <DetailWrap>
        <TimeIcon />
        <DetailText>{duration}</DetailText>
      </DetailWrap>
    </Container>
  );
};

export default ConsultationPriceDetails;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
`;

const DetailWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  p {
    white-space: nowrap;
  }
`;

const Price = styled(BodyBold)`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${Colors.navyBlue};
  font-family: 'Domaine';
  font-size: 18px;

  sup {
    top: -2px;
    margin-left: 2px;
    font-size: 65%;
  }
`;

const PriceWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const OriginalPrice = styled(Price)`
  text-decoration: line-through;
  color: ${Colors.navyBlue};
  opacity: 0.5;
`;

const DiscountedPrice = styled(Price)`
  color: ${Colors.lilac};
`;

const DetailText = styled(BodyBold)`
  display: flex;
  align-items: center;
  text-align: center;
  color: ${Colors.navyBlue};
  font-family: 'Domaine';
  font-size: 20px;
  line-height: 110%;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  sup {
    top: -2px;
    margin-left: 2px;
    font-size: 65%;
  }
`;
